export default "__VITE_ASSET__245bb616__"